import { useEffect } from 'react';

export const useInterval = (callback: Function, delay: number) => {
  useEffect(() => {
    const counterId = setInterval(() => callback(), delay);
    return () => clearInterval(counterId);
  }, [callback, delay]);
};
